import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/site';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('hero-cta-anchor');
    if (!anchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      // Show once the first CTA has scrolled out of view upwards.
      setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    }, {
      threshold: 0
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-36" data-mp="2aujlsee9pmfk">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 24
    }} transition={{
      duration: 0.24,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 sm:left-auto sm:right-5 sm:bottom-5 sm:w-auto sm:p-0" data-id="element-37" data-mp="2atqp6690wdb5">
          <div className="animate-shake" data-id="element-38" data-mp="333sue33nt8wc">
            <a href={CHECKOUT_URL} className="flex w-full items-center justify-center gap-2 rounded-2xl bg-go px-5 py-4 text-[13px] font-extrabold uppercase tracking-wide text-white shadow-go ring-2 ring-white/50 transition-colors duration-200 ease-out hover:bg-go-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-navy-700 sm:w-auto sm:text-sm" data-id="element-39" data-mp="335ng3jmr951h">
              <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-40" data-mp="26dtko5brw4c6" />
              <span data-id="element-41" data-mp="2bcdbok5846be">Get it now — $27</span>
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}